function throttle(callback, limit) {
  var waiting = false; // Initially, we're not waiting
  return function () {
    // We return a throttled function
    if (!waiting) {
      // If we're not waiting
      callback.apply(this, arguments); // Execute users function
      waiting = true; // Prevent future invocations
      setTimeout(function () {
        // After a period of time
        waiting = false; // And allow future invocations
      }, limit);
    }
  };
}

/**
 * Wrapper around Object.assign that deletes null or undefined
 * keys from the provided object, making them fall back to
 * values in the defaults object.
 *
 *
 * @param {Object} defaults - An object with defaults for settings/config
 * @param {Object} provided - Provided settings/config object
 * @returns {Object} - Merged object
 */

function objectWithDefaults(defaults, provided) {
  filterObjectByValues(provided, (value) => {
    return value === null || value === undefined;
  });

  return Object.assign(defaults, provided);
}

function wrapAll(nodes, wrapper) {
  // Cache the current parent and previous sibling of the first node.
  var parent = nodes[0].parentNode;
  var previousSibling = nodes[0].previousSibling;

  // Place each node in wrapper.
  //  - If nodes is an array, we must increment the index we grab from
  //    after each loop.
  //  - If nodes is a NodeList, each node is automatically removed from
  //    the NodeList when it is removed from its parent with appendChild.
  for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
    wrapper.appendChild(nodes[i]);
  }

  // Place the wrapper just after the cached previousSibling
  parent.insertBefore(wrapper, previousSibling.nextSibling);

  return wrapper;
}

function unwrap(wrapper) {
  // place childNodes in document fragment
  var docFrag = document.createDocumentFragment();
  while (wrapper.firstChild) {
    var child = wrapper.removeChild(wrapper.firstChild);
    docFrag.appendChild(child);
  }

  // replace wrapper with document fragment
  wrapper.parentNode.replaceChild(docFrag, wrapper);
}

function initTeleport(el) {
  if (!el) return;

  const teleportCandidates = el.querySelectorAll('[data-should-teleport]');

  if (teleportCandidates.length) {
    teleportCandidates.forEach((teleportCandidate) => {
      teleportCandidate.setAttribute(
        'x-teleport',
        teleportCandidate.dataset.shouldTeleport
      );
    });
  }
}

async function fetchSectionHTML(url, selector) {
  const res = await fetch(url);
  const fetchedSection = await res.text();
  const result = querySelectorInHTMLString(selector, fetchedSection);
  if (result === null) {
    return null;
  } else {
    return result.innerHTML;
  }
}

function fetchConfigDefaults(type = 'json') {
  return {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;',
      Accept: `application/${type}`,
    },
  };
}

function parseDOMFromString(htmlString) {
  window.___shapesDOMParser = window.___shapesDOMParser || new DOMParser();

  return window.___shapesDOMParser.parseFromString(htmlString, 'text/html');
}

function querySelectorInHTMLString(selector, htmlString) {
  return parseDOMFromString(htmlString).querySelector(selector);
}

let touchDevice = false;

window.setTouch = function () {
  touchDevice = true;
};

window.isTouch = function () {
  return touchDevice;
};

function getModalLabel(modalSlotName, slotEl) {
  if (Alpine.store('modals')[modalSlotName].open) {
    const labelSourceEl = Array.from(slotEl.children).filter((el) =>
      el.hasAttribute('data-modal-label')
    )[0];

    if (labelSourceEl) {
      return labelSourceEl.dataset.modalLabel;
    }
  }

  return false;
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


var wheelCta = {
    init: function(){
        // SI ON EST SUR LA HOME
        if(document.body.classList.contains('template-index')){
            wheelCta.obj = document.getElementById('wheel-is');
            wheelCta.trigger = document.querySelector('.wheel-bloc');
            wheelCta.state = 'hide';
            
            wheelCta.obj.classList.add('hide');

            wheelCta.calculate();
            wheelCta.watchScroll();

            window.addEventListener('resize', function(){
                wheelCta.calculate();
            });
        }
    },
    
    calculate: function(){
        wheelCta.windowHeight = window.innerHeight;
        // Enregistre la position dans la page pour déclencher l'effet au scroll
        wheelCta.start = Math.round(wheelCta.trigger.getBoundingClientRect().top + window.scrollY) - (wheelCta.windowHeight / 2);
        wheelCta.stop = Math.round(wheelCta.trigger.getBoundingClientRect().top + window.scrollY) - (wheelCta.windowHeight / 2) + (wheelCta.trigger.offsetHeight/1.6);
        
        if (responsive.isMobile()) {
            wheelCta.start = Math.round(wheelCta.trigger.getBoundingClientRect().top + window.scrollY) - (wheelCta.windowHeight / 2.1);
            wheelCta.stop = Math.round(wheelCta.trigger.getBoundingClientRect().top + window.scrollY) - (wheelCta.windowHeight / 2) + (wheelCta.trigger.offsetHeight/1.3);
        }
    },

    watchScroll: function(){
        document.addEventListener('scroll', function(){
            let currentScroll = window.scrollY;
            // AFFICHE LE WHEEL CTA "SOPEXA C'EST"
            if(currentScroll > wheelCta.start && currentScroll < wheelCta.stop){
                if(wheelCta.state === 'hide'){
                    wheelCta.state = 'show';
                    wheelCta.obj.classList.remove('hide');
                    wheelCta.obj.classList.remove('fixed');
                }
            } else if(currentScroll > wheelCta.stop) {
                if(wheelCta.state === 'show'){
                    wheelCta.state = 'hide';
                    wheelCta.obj.classList.add('fixed');
                }
            } else {
                if(wheelCta.state === 'show'){
                    wheelCta.state = 'hide';
                    wheelCta.obj.classList.add('hide');
                }
            }
        });
    },
};

// Assuming responsive is an existing object with isMobile method
var responsive = {
    isMobile: function() {
        // Implement your logic to determine if the device is mobile
        return window.innerWidth <= 768;
    }
};


document.addEventListener("DOMContentLoaded", function() {
  var $slides = document.querySelectorAll('.slide');
  var numOfSlides = $slides.length;
  var slidingAT = 1300; // sync this with scss variable
  var slidingBlocked = false;
  var currentIndex = 0;

  [].slice.call($slides).forEach(function($el, index) {
    var i = index + 1;
    $el.classList.add('slide-' + i);
    $el.dataset.slide = i;
  });

  function goToNextSlide() {
    if (slidingBlocked) return;
    slidingBlocked = true;

    var $curActive = document.querySelector('.slide.s--active');
    var index = +$curActive.dataset.slide;
    index++;
    if (index < 1) index = numOfSlides;
    if (index > numOfSlides) index = 1;
    var $newActive = document.querySelector('.slide-' + index);

    $curActive.classList.remove('s--active', 's--active-prev');
    document.querySelector('.slide.s--prev').classList.remove('s--prev');
    
    $newActive.classList.add('s--active');

    var prevIndex = index - 1;
    if (prevIndex < 1) prevIndex = numOfSlides;

    document.querySelector('.slide-' + prevIndex).classList.add('s--prev');

    setTimeout(function() {
      slidingBlocked = false;
    }, slidingAT * 0.75);
  };

  setInterval(goToNextSlide, 2000);
  wheelCta.init();
});

/*
document.addEventListener("DOMContentLoaded", function() {
  var slides = document.querySelectorAll('.custom-slider .slide');
  var currentSlide = 0;

  function showSlide(index) {
    slides.forEach(function(slide, i) {
      slide.classList.remove('active');
      if (i === index) {
        slide.classList.add('active');
      }
    });
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  // Show the first slide initially
  showSlide(currentSlide);

  // Change slide every 5 seconds
  setInterval(nextSlide, 1000);

  wheelCta.init();
});
*/
